<template>
  <button
    type="button"
    role="button"
    :class="['button-medium', currentState, className]"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @click="handleClick"
    :disabled="disableState"
  >
    <div :class="[divClassName]">{{ text }}</div>
  </button>
</template>

<script setup>
import { ref, watch, defineProps } from 'vue';

const props = defineProps({
  property1: {
    type: String,
    default: 'default',
    validator: value => ['click', 'hover', 'default'].includes(value),
  },
  className: {
    type: String,
    default: '',
  },
  divClassName: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: 'Anmelden',
  },
  disableState: {
    type: Boolean,
    default: false,
  },
});

const currentState = ref(props.property1);

watch(
    () => props.property1,
    (newVal) => {
      currentState.value = newVal;
    }
);

function handleMouseEnter() {
  currentState.value = 'hover';
}

function handleMouseLeave() {
  currentState.value = 'default';
}

function handleClick() {
  currentState.value = 'click';
}
</script>

<style lang="scss" scoped>
.button-medium {
  background-size: 100% 100%;
  position: relative;
  .loginBtn {
    font-family: "DIN Pro-Bold", Helvetica;
    font-weight: 700;
    left: 12px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 5px;
  }
  &.hover {
    .loginBtn {
      color: #ffffff;
    }
  }
  &.default {
    .loginBtn {
      color: #ffffff;
    }
  }
  &.click {
    .loginBtn {
      color: #000000;
    }
  }
}
</style>
